import { Box, Text } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const Column = styled(Box)`
  gap: 2px;
`

export const OneLineText = styled(Text)`
  p {
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    text-transform: capitalize;
  }
`
